import React, { Suspense, useEffect } from 'react';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { PageLoader } from '@/widgets/PageLoader';
import { routeConfig } from '../lib/routeConfig';
import { noAuthConfig } from '@/app/providers/router/lib/noAuthConfig';
import { useAppSelector } from '@/shared/lib/hooks/redux';
import { useGetProfileDataQuery } from '@/entities/Profile';
import { Alert } from '@/entities/Alert';
import { shouldPreloadTechnocoin, setOwnerPreloadFlag, clearOwnerPreloadFlag } from '@/shared/lib/preloadTechnocoin';

import { BlockedPage } from '@/pages/BlockedPage';

const preloadTechnocoinAssets = (): void => {
  void import('@/shared/lib/preloadTechnocoin/preloadTechnocoinAssets').then((m) => m.preloadTechnocoinAssets());
};

const router = createBrowserRouter(routeConfig);
const noAuthRouter = createBrowserRouter(noAuthConfig);

const AppRouter = () => {
  const { isAuth, isAuthLoading } = useAppSelector((state) => state.app);
  const { isOpen } = useAppSelector((state) => state.alert);

  const hasToken = document.cookie.includes('token=') || !!sessionStorage.getItem('token');
  const isLivePage = window.location.pathname.startsWith('/live/');

  const { data: profile, isLoading } = useGetProfileDataQuery(undefined, {
    skip: isLivePage || (!isAuth && !hasToken),
  });

  useEffect(() => {
    if (shouldPreloadTechnocoin()) {
      preloadTechnocoinAssets();
    }
  }, []);

  useEffect(() => {
    if (!profile) {
      return;
    }
    if (profile.isActive !== false && profile.accountType === 'club_account' && profile.role === 'owner') {
      setOwnerPreloadFlag();
      preloadTechnocoinAssets();
    } else {
      clearOwnerPreloadFlag();
    }
  }, [profile]);

  if (isAuth && profile && profile.isActive === false) {
    return <BlockedPage />;
  }

  return (
    <>
      <Suspense fallback={<PageLoader />}>
        {isAuthLoading || isLoading ? <PageLoader /> : <RouterProvider router={isAuth ? router : noAuthRouter} />}
      </Suspense>

      {isOpen && <Alert />}
    </>
  );
};

export default AppRouter;
